/**
 * 生成pdf文件
 */
<template>
  <div  style="display: flex; justify-content: space-between">
    <div class="body"  ref="contentToConvert">
      <div id="myContent" class="b1">
        <div class="page">
          <div
            class="s1"
            style="
              padding-left: 25pt;
              padding-top: 75px;
              text-indent: 0pt;
              text-align: left;
              position: relative;
              height: 75pt;
            "
          >
            <span>
              <img
                :width="imgUrlObj.imageUrl1.w"
                :height="imgUrlObj.imageUrl1.h"
                :style="{
                  position: 'absolute',
                  left: imgUrlObj.imageUrl1.left + 'px',
                  top: imgUrlObj.imageUrl1.top + 'px',
                  cursor: 'pointer',
                }"
                alt="image"
                :src="imgUrlObj.imageUrl1.url"
                @click="imageClickFn('imageUrl1')"
            /></span>
            <span>
              <img
                :width="imgUrlObj.imageUrl2.w"
                :height="imgUrlObj.imageUrl2.h"
                :style="{
                  position: 'absolute',
                  left: imgUrlObj.imageUrl2.left + 'px',
                  top: imgUrlObj.imageUrl2.top + 'px',
                  cursor: 'pointer',
                }"
                alt="image"
                :src="imgUrlObj.imageUrl2.url"
                @click="imageClickFn('imageUrl2')" /></span
            ><span class="s2"> </span>
            <span>
              <img
                :width="imgUrlObj.imageUrl3.w"
                :height="imgUrlObj.imageUrl3.h"
                :style="{
                  position: 'absolute',
                  left: imgUrlObj.imageUrl3.left + 'px',
                  top: imgUrlObj.imageUrl3.top + 'px',
                  cursor: 'pointer',
                }"
                alt="image"
                :src="imgUrlObj.imageUrl3.url"
                @click="imageClickFn('imageUrl3')"
              />
            </span>
          </div>
          <h1
            style="padding-top: 22pt; text-indent: 0pt; text-align: center"
            @click="textClickFn('one', 'reportTitle')"
          >
            {{ reportFileds["one"].reportTitle }}
          </h1>
          <p
            class="s3"
            style="padding-top: 40pt; text-indent: 0pt; text-align: center"
          >
            <span style="font-size: 20px">报告编号：</span
            ><span
              style="font-family: 'Times New Roman'"
              @click="textClickFn('one', 'reportNumber')"
              >{{ reportFileds["one"].reportNumber }}</span
            >
          </p>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p
            class="s4"
            style="
              padding-left: 40pt;
              text-indent: 0pt;
              text-align: left;
              margin-top: 140px;
            "
          >
            <span style="font-size: 20px; letter-spacing: 3px">样品名称：</span>
            <span
              class="s3"
              style="
                display: inline-block;
                text-align: center;
                margin-left: -10px;
                border-bottom: 3px solid black;
                width: 466px;
              "
              @click="textClickFn('one', 'sampleName')"
              >{{ reportFileds["one"].sampleName }}</span
            >
          </p>
          <p
            class="s4"
            style="
              padding-left: 40pt;
              text-indent: 0pt;
              text-align: left;
              margin-top: 13.62px;
            "
          >
            <span
              style="
                font-size: 20px;
                letter-spacing: 3px;
                color: #fff;
                font-weight: bolder;
              "
              >样品名称：</span
            >
            <span
              class="s3"
              style="
                display: inline-block;
                text-align: center;
                margin-left: -10px;
                width: 466px;
              "
              @click="textClickFn('one', 'unit')"
              >{{ reportFileds["one"].unit }}</span
            >
          </p>
          <p
            class="s4"
            style="
              padding-left: 40pt;
              text-indent: 0pt;
              text-align: left;
              margin-top: 2px;
            "
          >
            <span style="font-size: 20px; letter-spacing: 3px">委托单位：</span>
            <span
              class="s3"
              style="
                display: inline-block;
                text-align: center;
                margin-left: -10px;
                border-bottom: 3px solid black;
                width: 466px;
              "
              @click="textClickFn('one', 'depart')"
              >{{ reportFileds["one"].depart }}</span
            >
          </p>
          <p
            class="s4"
            style="
              padding-left: 40pt;
              text-indent: 0pt;
              text-align: left;
              margin-top: 40px;
            "
          >
            <span style="font-size: 20px; letter-spacing: 3px">检测类别：</span>
            <span
              class="s3"
              style="
                display: inline-block;
                text-align: center;
                margin-left: -10px;
                border-bottom: 3px solid black;
                width: 466px;
              "
              @click="textClickFn('one', 'type')"
              >{{ reportFileds["one"].type }}</span
            >
          </p>
          <div style="position: relative">
            <div
              style="
                text-indent: 0pt;
                width: fit-content;
                text-align: left;
                position: absolute;
                top: -50px;
                left: 50%;
                background: transparent;
                transform: translateX(-50%);
                z-index: 2;
              "
            >
              <img
                :width="imgUrlObj.imageUrl4.w"
                :height="imgUrlObj.imageUrl4.h"
                :style="{
                  display: ' block',
                  'margin-left': imgUrlObj.imageUrl4.left + 'px',
                  'margin-top': imgUrlObj.imageUrl4.top + 'px',
                  cursor: 'pointer',
                  background: 'transparent',
                }"
                alt="image"
                :src="imgUrlObj.imageUrl4.url"
                @click="imageClickFn('imageUrl4')"
              />
            </div>
            <div style="position: relative; margin-top: 181px">
              <p
                class="s5"
                style="
                  text-indent: 0pt;
                  text-align: center;
                  letter-spacing: 2px;
                "
                @click="textClickFn('one', 'company')"
              >
                {{ reportFileds["one"].company }}
              </p>
              <p
                class="s5"
                style="
                  text-indent: 0pt;
                  text-align: center;
                  letter-spacing: 12px;
                  margin-left: 8px;
                "
                @click="textClickFn('one', 'testCenter')"
              >
                {{ reportFileds["one"].testCenter }}
              </p>
            </div>
          </div>
        </div>

        <div class="page">
          <div
            style="
              display: flex;
              align-items: flex-start;
              width: 546px;
              margin-top: 50px;
              position: relative;
            "
          >
            <div style="flex: 1; text-align: left">
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 1pt;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 4.4px;
                "
                @click="textClickFn('one', 'company')"
              >
                {{ reportFileds["one"].company }}
              </h4>
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 7px;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 15.2px;
                "
                @click="textClickFn('one', 'testCenter')"
              >
                {{ reportFileds["one"].testCenter }}
              </h4>
            </div>
            <img
              :style="{
                position: 'absolute',
                left: imgUrlObj.imageUrl5.left + 'px',
                top: imgUrlObj.imageUrl5.top + 'px',
                cursor: 'pointer',
              }"
              :width="imgUrlObj.imageUrl5.w"
              :height="imgUrlObj.imageUrl5.h"
              alt="image"
              :src="imgUrlObj.imageUrl5.url"
              @click="imageClickFn('imageUrl5')"
            />
          </div>

          <h3
            style="
              padding-top: 14px;
              text-indent: 0pt;
              line-height: 34pt;
              text-align: center;
              font-family: 'SimHei';
              letter-spacing: 0.7px;
            "
            @click="textClickFn('one', 'reportTitle')"
          >
            {{ reportFileds["one"].reportTitle }}
          </h3>
          <div style="width:641.5px;border-bottom: 1px solid black; padding-bottom: 3px; margin-left: 1.5px; margin-right: 1px">
            <p
              style="
                display: flex;
                justify-content: space-between;
                padding-left: 10px;
                text-indent: 0pt;
                line-height: 14pt;
                text-align: left;
              "
            >
              <span class="s6" style="font-family: '宋体'; font-size: 14px"
                >报告编号：<span
                  style="font-family: 'Times New Roman'; font-size: 16px"
                  @click="textClickFn('one', 'reportNumber')"
                  >{{ reportFileds["one"].reportNumber }}</span
                ></span
              >
              <span
                style="
                  text-align: right;
                  letter-spacing: 3px;
                  padding-right: 7px;
                  font-size: 14px;
                "
                >共<span style="font-family: 'Times New Roman'; font-size: 14px"
                  >7</span
                >页第<span
                  style="font-family: 'Times New Roman'; font-size: 14px"
                  >1</span
                >页</span
              >
            </p>
          </div>
          <div style="position: relative">
            <img
              :width="imgUrlObj.imageUrl6.w"
              :height="imgUrlObj.imageUrl6.h"
              :style="{
                position: 'absolute',
                'z-index': 99,
                left: imgUrlObj.imageUrl6.left + 'px',
                top: imgUrlObj.imageUrl6.top + 'px',
                'background-color': 'transparent',
                cursor: 'pointer',
              }"
              alt="image"
              :src="imgUrlObj.imageUrl6.url"
              @click="imageClickFn('imageUrl6')"
            />
            <div style="position: relative; margin-top: 1.5px">
              <table style="width:644.5px;border-spacing: 0; border: 2px solid black;">
                <tr
                  style="height: 27pt"
                  v-for="(item, index) in reportPage1"
                  :key="index"
                >
                <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'center' && item.fieldName == '委托单位'"
                    style="
                      width: 79pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    @click="
                      textClickPageOneFn(index, 'fieldName', item.fieldName)
                    "
                  >
                    <p class="s7" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldName }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'center' && item.fieldName == '委托单位'"
                    style="
                      width: 400pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    colspan="3"
                    @click="
                      textClickPageOneFn(index, 'fieldValue', item.fieldValue)
                    "
                  >
                    <p class="s8" :style="{'text-indent': '0pt', 'text-align': item.textAlign, 'line-height': item.lineHeight +'pt','white-space': 'pre'}" >{{ item.fieldValue }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'center' && item.fieldName != '委托单位'"
                    style="
                      width: 79pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    @click="
                      textClickPageOneFn(index, 'fieldName', item.fieldName)
                    "
                  >
                    <p class="s7" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldName }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'center' && item.fieldName != '委托单位'"
                    style="
                      width: 400pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    colspan="3"
                    @click="
                      textClickPageOneFn(index, 'fieldValue', item.fieldValue)
                    "
                  >
                    <p class="s8" :style="{'text-indent': '0pt', 'text-align': item.textAlign, 'line-height': item.lineHeight +'pt','white-space': 'pre'}" >{{ item.fieldValue }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'left' && item.fieldName == '判定依据 *'"
                    style="
                      width: 79pt;
                      height: 32pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    @click="
                      textClickPageOneFn(index, 'fieldName', item.fieldName)
                    "
                  >
                    <p class="s7" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldName }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'left' && item.fieldName == '判定依据 *'"
                    style="
                      width: 400pt;
                      height: 32pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    colspan="3"
                    @click="
                      textClickPageOneFn(index, 'fieldValue', item.fieldValue)
                    "
                  >
                    <p class="s8" :style="{'text-indent': '0pt', 'padding-left': '5pt', 'text-align': item.textAlign, 'line-height': item.lineHeight +'pt','white-space': 'pre'}" >{{ item.fieldValue }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'left' && item.fieldName != '判定依据 *'"
                    style="
                      width: 79pt;
                      height: 28pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    @click="
                      textClickPageOneFn(index, 'fieldName', item.fieldName)
                    "
                  >
                    <p class="s7" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldName }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 4 && item.textAlign == 'left' && item.fieldName != '判定依据 *'"
                    style="
                      width: 400pt;
                      height: 28pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                    colspan="3"
                    @click="
                      textClickPageOneFn(index, 'fieldValue', item.fieldValue)
                    "
                  >
                    <p class="s8" :style="{'text-indent': '0pt', 'padding-left': '5pt', 'text-align': item.textAlign, 'line-height': item.lineHeight +'pt','white-space': 'pre'}" >{{ item.fieldValue }}</p>
                  </td>
                  <td
                    @click="
                      textClickPageOneFn(index, 'fieldName', item.fieldName)
                    "
                    v-if="Object.keys(item).length == 5"
                    style="
                      width: 79pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                  >
                    <p class="s7" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldName }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 5"
                    @click="
                      textClickPageOneFn(index, 'fieldValue', item.fieldValue)
                    "
                    style="
                      width: 182pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                  >

                    <p class="s8" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldValue }}</p>
                  </td>
                  <td
                    v-if="Object.keys(item).length == 5"
                    @click="
                      textClickPageOneFn(index, 'fieldName2', item.fieldName2)
                    "
                    style="
                      width: 77pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                  >
                    <p class="s7" :style="{'text-indent': '0pt', 'text-align': 'center', 'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldName2 }}</p>
                  </td>
                  <td
                    @click="
                      textClickPageOneFn(index, 'fieldValue2', item.fieldValue2)
                    "
                    v-if="Object.keys(item).length == 5"
                    style="
                      width: 139pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                  >

                    <p class="s8" :style="{'text-indent': '0pt', 'text-align': 'center',
                       'line-height': item.lineHeight+'pt','white-space': 'pre'}" >{{ item.fieldValue2 }}</p>
                  </td>
                </tr>
                <tr style="height: 70pt">
                  <td
                    style="
                      width: 79pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                  >

                    <p class="s7" style="text-indent: 0pt; text-align: center">
                      检测结论
                    </p>
                  </td>
                  <td
                    style="
                      width: 400pt;
                      border: 1px solid black !important;
                    "
                    colspan="3"
                  >
                    <p
                      style="
                        padding-top: 6pt;
                        text-indent: 0pt;
                        text-align: left;
                      "
                    >
                      <br />
                    </p>
                    <p
                      class="s8"
                      :style="{
                        'padding-left': '5pt',
                        'text-indent': '0pt',
                        'text-align': 'left',
                        // 'letter-spacing': spaceObj.result + 'pt',
                        'line-height': spaceObj.result+'pt',
                        'white-space': 'pre',
                      }"
                      @click="textClickFn('two', 'testConclusion')"
                    >{{ reportFileds["two"].testConclusion }}</p>
                    <p
                      style="
                        padding-top: 6pt;
                        text-indent: 0pt;
                        text-align: left;
                      "
                    >
                      <br />
                    </p>
                    <p
                      class="s8"
                      :style="{
                        'padding-left': '205pt',
                        'text-indent': '0pt',
                        'text-align': 'left',
                        // 'letter-spacing': spaceObj.date + 'pt',
                        'line-height': spaceObj.date+'pt',
                        'white-space': 'pre',
                      }"
                      @click="textClickFn('two', 'dateIssue')"
                    >
                      <span class="s7">签发日期：</span
                      ><span style="margin-left:5pt">{{ reportFileds["two"].dateIssue }}</span></p>
                  </td>
                </tr>
                <tr style="height: 32pt">
                  <td
                    style="
                      width: 79pt;
                      border: 1px solid black !important;
                      vertical-align: middle;
                    "
                  >
                    <p class="s7" style="text-indent: 0pt; text-align: center">
                      备注
                    </p>
                  </td>
                  <td
                    style="
                      width: 400pt;
                      border: 1px solid black !important;
                    "
                    colspan="3"
                    @click="textClickFn('two', 'remark')"
                  >
                    <p
                      v-for="(item, index) in reportFileds['two'].remark.split(
                        '；'
                      )"
                      :key="item"
                      class="s8"
                      style="
                        padding-left: 13pt;
                        padding-top: 2pt;
                        text-indent: -8pt;
                        text-align: left;
                      "
                    >
                      <span style="font-family: 'Times New Roman'"
                        >{{ index + 1 }}.</span
                      >{{ item }}
                    </p>

                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div
            style="
              position: relative;
              display: flex;
              justify-content: space-between;
            "
          >
            <div
              style="
                float: left;
                padding-top: 16.5pt;
                padding-left: 18pt;
                text-indent: 0pt;
                text-align: left;
                font-family: '宋体';
                font-size: 15px;
              "
            >
              批准：
            </div>
            <div style="float: left; padding-top: 1pt; padding-left: 2pt">
              <img
                :width="imgUrlObj.imageUrl7.w"
                :height="imgUrlObj.imageUrl7.h"
                alt="image"
                :src="imgUrlObj.imageUrl7.url"
                @click="imageClickFn('imageUrl7')"
                :style="{
                  position: 'absolute',
                  left: imgUrlObj.imageUrl7.left + 'px',
                  top: imgUrlObj.imageUrl7.top + 'px',
                  cursor: 'pointer',
                }"
              />
            </div>

            <div
              style="
                float: left;
                padding-top: 16.5pt;
                /* padding-left: 67pt; */
                text-indent: 0pt;
                text-align: left;
                font-family: '宋体';
                font-size: 15px;
              "
            >
              审核：
            </div>
            <div style="float: left; margin-left: -10px; padding-top: 1pt">
              <img
                :width="imgUrlObj.imageUrl9.w"
                :height="imgUrlObj.imageUrl9.h"
                alt="image"
                :src="imgUrlObj.imageUrl9.url"
                @click="imageClickFn('imageUrl9')"
                :style="{
                  position: 'absolute',
                  left: imgUrlObj.imageUrl9.left + 'px',
                  top: imgUrlObj.imageUrl9.top + 'px',
                  cursor: 'pointer',
                }"
              />
            </div>

            <div
              style="
                float: left;
                padding-top: 16.5pt;
                /* padding-left: 34pt; */
                text-indent: 0pt;
                text-align: left;
                font-family: '宋体';
                font-size: 15px;
              "
            >
              主检：
            </div>
            <div style="float: left; padding-top: 7pt; padding-left: 11pt">
              <img
                :width="imgUrlObj.imageUrl8.w"
                :height="imgUrlObj.imageUrl8.h"
                alt="image"
                :src="imgUrlObj.imageUrl8.url"
                @click="imageClickFn('imageUrl8')"
                :style="{
                  position: 'absolute',
                  left: imgUrlObj.imageUrl8.left + 'px',
                  top: imgUrlObj.imageUrl8.top + 'px',
                  cursor: 'pointer',
                }"
              />
            </div>
          </div>
          <div style="clear: both"></div>
          <!-- 清除浮动影响 -->
        </div>
        <div class="page">
          <div
            style="
              display: flex;
              align-items: flex-start;
              width: 546px;
              margin-top: 50px;
              position: relative;
            "
          >
            <div style="flex: 1; text-align: left">
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 1pt;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 4.4px;
                "
                @click="textClickFn('one', 'company')"
              >
                {{ reportFileds["one"].company }}
              </h4>
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 7px;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 15.2px;
                "
                @click="textClickFn('one', 'testCenter')"
              >
                {{ reportFileds["one"].testCenter }}
              </h4>
            </div>
            <img
              :style="{
                position: 'absolute',
                left: imgUrlObj.imageUrl5.left + 'px',
                top: imgUrlObj.imageUrl5.top + 'px',
                cursor: 'pointer',
              }"
              :width="imgUrlObj.imageUrl5.w"
              :height="imgUrlObj.imageUrl5.h"
              alt="image"
              :src="imgUrlObj.imageUrl5.url"
              @click="imageClickFn('imageUrl5')"
            />
          </div>

          <h3
            style="
              padding-top: 14px;
              text-indent: 0pt;
              line-height: 34pt;
              text-align: center;
              font-family: 'SimHei';
              letter-spacing: 0.7px;
            "
            @click="textClickFn('one', 'reportTitle')"
          >
            {{ reportFileds["one"].reportTitle }}
          </h3>
          <div style="width:641.5px;border-bottom: 1px solid black; padding-bottom: 3px; margin-left: 1.5px; margin-right: 1px">
            <p
              style="
                display: flex;
                justify-content: space-between;
                padding-left: 10px;
                text-indent: 0pt;
                line-height: 14pt;
                text-align: left;
              "
            >
              <span class="s6" style="font-family: '宋体'; font-size: 14px"
                >报告编号：<span
                  style="font-family: 'Times New Roman'; font-size: 16px"
                  @click="textClickFn('one', 'reportNumber')"
                  >{{ reportFileds["one"].reportNumber }}</span
                ></span
              >
              <span
                style="
                  text-align: right;
                  letter-spacing: 3px;
                  padding-right: 7px;
                  font-size: 14px;
                "
                >共<span style="font-family: 'Times New Roman'; font-size: 14px"
                  >7</span
                >页第<span
                  style="font-family: 'Times New Roman'; font-size: 14px"
                  >2</span
                >页</span
              >
            </p>
          </div>
          <table
            style="
              width:644.5px;
              border-spacing: 0;
              border: 2px solid black;
              margin-top: 1.5px;

            "
            cellspacing="0"
          >
            <tr style="height: 34pt">
              <td
                style="
                  width: 113pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  探头规格
                </p>
              </td>
              <td
                @click="textClickFn('three', 't1')"
                style="
                  width: 156pt;
                  border: 1px solid black !important;
                "
              >
                <p
                  v-for="item in reportFileds['three'].t1.split('，')"
                  :key="item"
                  class="s8"
                  style="
                    padding-top: 3pt;
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item }}
                </p>
              </td>
              <td
                style="
                  width: 99pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="
                    padding-left: 1pt;
                    text-indent: 0pt;
                    text-align: center;
                  "
                >
                  检测等级
                </p>
              </td>
              <td
                style="
                  width: 116pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="
                    padding-left: 1pt;
                    text-indent: 0pt;
                    text-align: center;
                  "
                  @click="textClickFn('three', 't2')"
                >
                  <span style="font-family: 'Times New Roman'"
                    >{{ reportFileds["three"].t2 }} </span
                  >级
                </p>
              </td>
            </tr>
            <tr style="height: 34pt">
              <td
                style="
                  width: 113pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  试块
                </p>
              </td>
              <td
                style="
                  width: 156pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                  @click="textClickFn('three', 't3')"
                >
                  {{ reportFileds["three"].t3 }}
                </p>
              </td>
              <td
                style="
                  width: 99pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  检测灵敏度
                </p>
              </td>
              <td
                style="
                  width: 116pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                  @click="textClickFn('three', 't4')"
                >
                  {{ reportFileds["three"].t4 }}
                </p>
              </td>
            </tr>
            <tr style="height: 34pt">
              <td
                style="
                  width: 113pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  表面状态
                </p>
              </td>
              <td
                style="
                  width: 156pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="text-indent: 0pt; text-align: center"
                  @click="textClickFn('three', 't5')"
                >
                  {{ reportFileds["three"].t5 }}
                </p>
              </td>
              <td
                style="
                  width: 99pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  质量等级
                </p>
              </td>
              <td
                style="
                  width: 116pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="
                    padding-right: 1pt;
                    text-indent: 0pt;
                    text-align: center;
                  "
                  @click="textClickFn('three', 't6')"
                >
                  <span style="font-family: 'Times New Roman'">
                    {{ reportFileds["three"].t6 }} </span
                  >级
                </p>
              </td>
            </tr>
            <tr style="height: 34pt">
              <td
                style="
                  width: 113pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  扫查方式
                </p>
              </td>
              <td
                @click="textClickFn('three', 't7')"
                style="
                  width: 156pt;
                  border: 1px solid black !important;
                "
              >
                <p
                  class="s8"
                  v-for="item in reportFileds['three'].t7.split('，')"
                  :key="item"
                  style="
                    text-indent: 0pt;
                    line-height: 16pt;
                    text-align: center;
                    padding-top: 2pt;
                  "
                >
                  {{ item }}
                </p>
              </td>
              <td
                style="
                  width: 99pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  焊接方法
                </p>
              </td>
              <td
                style="
                  width: 116pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="text-indent: 0pt; text-align: center"
                  @click="textClickFn('three', 't8')"
                >
                  {{ reportFileds["three"].t8 }}
                </p>
              </td>
            </tr>
            <tr style="height: 34pt">
              <td
                style="
                  width: 113pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  扫描调节
                </p>
              </td>
              <td
                style="
                  width: 156pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="text-indent: 0pt; text-align: center"
                  @click="textClickFn('three', 't9')"
                >
                  {{ reportFileds["three"].t9 }}
                </p>
              </td>
              <td
                style="
                  width: 99pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  耦合剂
                </p>
              </td>
              <td
                style="
                  width: 116pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="text-indent: 0pt; text-align: center"
                  @click="textClickFn('three', 't10')"
                >
                  {{ reportFileds["three"].t10 }}
                </p>
              </td>
            </tr>
            <tr style="height: 34pt">
              <td
                style="
                  width: 113pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  检测时机
                </p>
              </td>
              <td
                style="
                  width: 156pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="text-indent: 0pt; text-align: center"
                  @click="textClickFn('three', 't11')"
                >
                  {{ reportFileds["three"].t11 }}
                </p>
              </td>
              <td
                style="
                  width: 99pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p class="s8" style="text-indent: 0pt; text-align: center">
                  表面补偿
                </p>
              </td>
              <td
                style="
                  width: 116pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                "
              >
                <p
                  class="s8"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                  @click="textClickFn('three', 't12')"
                >
                  {{ reportFileds["three"].t12 }}
                </p>
              </td>
            </tr>
            <tr style="height: 407pt">
              <td
                style="
                  width: 484pt;
                  border: 1px solid black !important;
                "
                colspan="4"
              >
                <div
                  class="s8"
                  style="
                    padding-left: 5pt;
                    padding-top: 2pt;
                    text-indent: 0pt;
                    text-align: left;
                    height: 407pt;
                    position: relative;
                    overflow: hidden;
                  "
                >
                  示意图：
                  <img
                    :width="imgUrlObj.imageUrl11.w"
                    :height="imgUrlObj.imageUrl11.h"
                    alt="image"
                    :src="imgUrlObj.imageUrl11.url"
                    @click="imageClickFn('imageUrl11')"
                    :style="{
                      position: 'absolute',
                      left: imgUrlObj.imageUrl11.left + 'px',
                      top: imgUrlObj.imageUrl11.top + 'px',
                      cursor: 'pointer',
                    }"
                  />
                </div>
                <!-- <p style="text-indent: 0pt; text-align: left"><br /></p>
                <p
                  style="
                    padding-left: 1pt;
                    padding-top: 30pt;
                    text-indent: 0pt;
                    text-align: left;

                  "
                >
                  <span
                    ></span>
                </p>
                <p style="text-indent: 0pt; text-align: left"><br /></p> -->
              </td>
            </tr>
          </table>
        </div>

        <div class="page" v-if="imgUrlObj.imageUrl13.show || imgUrlObj.imageUrl14.show || imgUrlObj.imageUrl15.show">
          <div
            style="
              display: flex;
              align-items: flex-start;
              width: 546px;
              margin-top: 50px;
              position: relative;
            "
          >
            <div style="flex: 1; text-align: left">
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 1pt;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 4.4px;
                "
                @click="textClickFn('one', 'company')"
              >
                {{ reportFileds["one"].company }}
              </h4>
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 7px;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 15.2px;
                "
                @click="textClickFn('one', 'testCenter')"
              >
                {{ reportFileds["one"].testCenter }}
              </h4>
            </div>
            <img
              :style="{
                position: 'absolute',
                left: imgUrlObj.imageUrl5.left + 'px',
                top: imgUrlObj.imageUrl5.top + 'px',
                cursor: 'pointer',
              }"
              :width="imgUrlObj.imageUrl5.w"
              :height="imgUrlObj.imageUrl5.h"
              alt="image"
              :src="imgUrlObj.imageUrl5.url"
              @click="imageClickFn('imageUrl5')"
            />
          </div>

          <h3
            style="
              padding-top: 14px;
              text-indent: 0pt;
              line-height: 34pt;
              text-align: center;
              font-family: 'SimHei';
              letter-spacing: 0.7px;
            "
            @click="textClickFn('one', 'reportTitle')"
          >
            {{ reportFileds["one"].reportTitle }}
          </h3>
          <div style="width:641.5px;border-bottom: 1px solid black; padding-bottom: 3px; margin-left: 1.5px; margin-right: 1px">
            <p
              style="
                display: flex;
                justify-content: space-between;
                padding-left: 10px;
                text-indent: 0pt;
                line-height: 14pt;
                text-align: left;
              "
            >
              <span class="s6" style="font-family: '宋体'; font-size: 14px"
                >报告编号：<span
                  style="font-family: 'Times New Roman'; font-size: 16px"
                  @click="textClickFn('one', 'reportNumber')"
                  >{{ reportFileds["one"].reportNumber }}</span
                ></span
              >
              <span
                style="
                  text-align: right;
                  letter-spacing: 3px;
                  padding-right: 7px;
                  font-size: 14px;
                "
                >共<span style="font-family: 'Times New Roman'; font-size: 14px"
                  >7</span
                >页第<span
                  style="font-family: 'Times New Roman'; font-size: 14px"
                  >3</span
                >页</span
              >
            </p>
          </div>
          <table
            style="
              width:644.5px;
              border-spacing: 0;
              border: 2px solid black;
              margin-top: 2px;
            "
            cellspacing="0"
          >
            <tr style="height: 807.13px">
              <td
                style="
                  width: 484pt;
                  border: 1px solid black !important;
                  position: relative;
                  overflow: hidden;
                "
                colspan="4"
              >
                <div
                  style="
                    padding-left: 5pt;
                    text-indent: 0pt;
                    text-align: center;
                  "
                >
                  <img
                    v-show="imgUrlObj.imageUrl13.show"
                    :width="imgUrlObj.imageUrl13.w"
                    :height="imgUrlObj.imageUrl13.h"
                    alt="image"
                    :src="imgUrlObj.imageUrl13.url"
                    @click="imageClickFn('imageUrl13')"
                    :style="{
                      position: 'absolute',
                      left: imgUrlObj.imageUrl13.left + 'px',
                      top: imgUrlObj.imageUrl13.top + 'px',
                      cursor: 'pointer',
                    }"
                  />

                  <img
                  v-show="imgUrlObj.imageUrl14.show"
                    :width="imgUrlObj.imageUrl14.w"
                    :height="imgUrlObj.imageUrl14.h"
                    alt="image"
                    :src="imgUrlObj.imageUrl14.url"
                    @click="imageClickFn('imageUrl14')"
                    :style="{
                      position: 'absolute',
                      left: imgUrlObj.imageUrl14.left + 'px',
                      top: imgUrlObj.imageUrl14.top + 'px',
                      cursor: 'pointer',
                    }"
                  />
                  <img
                  v-show="imgUrlObj.imageUrl15.show"
                    :width="imgUrlObj.imageUrl15.w"
                    :height="imgUrlObj.imageUrl15.h"
                    alt="image"
                    :src="imgUrlObj.imageUrl15.url"
                    @click="imageClickFn('imageUrl15')"
                    :style="{
                      position: 'absolute',
                      left: imgUrlObj.imageUrl15.left + 'px',
                      top: imgUrlObj.imageUrl15.top + 'px',
                      cursor: 'pointer',
                    }"
                  />
                </div>
                <p style="text-indent: 0pt; text-align: left"><br /></p>
              </td>
            </tr>
          </table>
        </div>
        <div class="page" v-for="page in pageTotal" :key="page">
          <div
            style="
              display: flex;
              align-items: flex-start;
              width: 546px;
              margin-top: 50px;
              position: relative;
            "
          >
            <div style="flex: 1; text-align: left">
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 1pt;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 4.4px;
                "
                @click="textClickFn('one', 'company')"
              >
                {{ reportFileds["one"].company }}
              </h4>
              <h4
                style="
                  padding-left: 10px;
                  padding-top: 7px;
                  text-indent: 0pt;
                  text-align: left;
                  width: 550px;
                  font-family: 'SimHei';
                  letter-spacing: 15.2px;
                "
                @click="textClickFn('one', 'testCenter')"
              >
                {{ reportFileds["one"].testCenter }}
              </h4>
            </div>

            <img
              :width="imgUrlObj.imageUrl5.w"
              :height="imgUrlObj.imageUrl5.h"
              alt="image"
              :src="imgUrlObj.imageUrl5.url"
              @click="imageClickFn('imageUrl5')"
              :style="{
                position: 'absolute',
                left: imgUrlObj.imageUrl5.left + 'px',
                top: imgUrlObj.imageUrl5.top + 'px',
                cursor: 'pointer',
              }"
            />
          </div>

          <h3
            style="
              padding-top: 14px;
              text-indent: 0pt;
              line-height: 34pt;
              text-align: center;
              font-family: 'SimHei';
              letter-spacing: 0.7px;
            "
            @click="textClickFn('one', 'reportTitle')"
          >
            {{ reportFileds["one"].reportTitle }}
          </h3>
          <div style="width:641.5px;border-bottom: 1px solid black; padding-bottom: 3px; margin-left: 1.5px; margin-right: 1px">
            <p
              style="
                display: flex;
                justify-content: space-between;
                padding-left: 10px;
                text-indent: 0pt;
                line-height: 14pt;
                text-align: left;
              "
            >
              <span class="s6" style="font-family: '宋体'; font-size: 14px"
                >报告编号：<span
                  style="font-family: 'Times New Roman'; font-size: 16px"
                  @click="textClickFn('one', 'reportNumber')"
                  >{{ reportFileds["one"].reportNumber }}</span
                ></span
              >
              <span
                style="
                  text-align: right;
                  letter-spacing: 3px;
                  padding-right: 7px;
                  font-size: 14px;
                "
                >共<span
                  style="font-family: 'Times New Roman'; font-size: 14px"
                  >{{ pageTotal + Number(`${imgUrlObj.imageUrl13.show || imgUrlObj.imageUrl14.show || imgUrlObj.imageUrl15.show ? 3 : 2}`) }}</span
                >页第<span
                  style="font-family: 'Times New Roman'; font-size: 14px"
                  >{{ page + Number(`${imgUrlObj.imageUrl13.show || imgUrlObj.imageUrl14.show || imgUrlObj.imageUrl15.show ? 3 : 2}`) }}</span
                >页</span
              >
            </p>
          </div>
          <table style="border-spacing: 0; border: 2.5px solid black; margin-top: 1.5px"
               cellspacing="0">
            <tr style="height: 19pt" v-if="tabelDataObj[page].length != 0">
                <td
                  style="width: 92pt; border: 1px solid black !important;"

                >
                  <p class="s8" style="padding-top: 2pt; padding-left: 35pt; padding-right: 32pt; text-indent: 0pt; text-align: center;">
                    焊缝编号
                  </p>
                </td>
                <td
                  style="width: 30pt; border: 1px solid black !important;"
                >
                  <p class="s8" style="padding-top: 2pt; padding-left: 1pt; padding-right: 1pt; text-indent: 0pt; text-align: center;">
                    质量等级
                  </p>
                </td>
                <td
                  style="width: 30pt; border: 1px solid black !important;"
                >
                  <p class="s8" style="padding-top: 3pt; padding-left: 0pt; text-indent: 1pt; text-align: center;">
                    检测长度<span style="font-family: 'Times New Roman'">(mm)</span>
                  </p>
                </td>
                <td
                  style="width: 30pt; border: 1px solid black !important;"
                >
                  <p class="s8" style="padding-top: 3pt; padding-left: 0pt; text-indent: 1pt; text-align: center;">
                    焊缝规格<span style="font-family: 'Times New Roman'">(mm)</span>
                  </p>
                </td>
                <td
                  style="width: 30pt; border: 1px solid black !important;"
                >
                  <p class="s8" style="padding-top: 2pt; padding-left: 1pt; padding-right: 1pt; text-indent: 0pt; text-align: center;">
                    坡口形式
                  </p>
                </td>
                <td
              style="width: 224pt; border: 1px solid black !important; vertical-align: middle;"
              colspan="6"
            >
              <p class="s8" style="text-indent: 0pt; text-align: center; border-bottom: 0.15vw solid black; padding-top: 3px; padding-bottom: 3px;">
                缺欠
              </p>
              <p class="s8" style="text-indent: 0pt; text-align: center; display: flex; justify-content: space-between; flex-wrap: wrap;">
                <span style="width:34.5px; text-align: center;display: inline-block;padding-top:9px;">编号</span>
            <span style="width:51px;  border-left: 0.15vw solid black;">
              <p>横坐标</p>
              <p style="font-family: 'Times New Roman';">X (mm)</p>
            </span>
                <span style="width:51px;border-left: 0.15vw solid black;">
                  <p>纵坐标</p>
                  <p style="font-family: 'Times New Roman';">Y (mm)</p>
                </span>
                <span style="width:51px; border-left: 0.15vw solid black;">
                  <p>深度</p>
                  <p style="font-family: 'Times New Roman';">Z (mm)</p>
                </span>
                <span style="width:51px;border-left: 0.15vw solid black;">
                  <p>长度</p>
                  <p style="font-family: 'Times New Roman';">L (mm)</p>
                </span>
                <span style="width:51px; border-left: 0.15vw solid black;">
                  <p>波幅</p>
                  <p style="font-family: 'Times New Roman';">SL ± dB</p>
                </span>
              </p>
            </td>
                <td
                  style="width: 35pt; border: 1px solid black !important; vertical-align: middle;"

                >
                  <p class="s8" style="text-indent: 0pt; text-align: center;">
                    评定
                  </p>
                </td>
            </tr>
            <tr
              :style="{
                height:
                  item.Evaluation == '复检合格'
                    ? 2 * tableHeight + 'pt'
                    : tableHeight + 'pt',
                'line-height': tableHeight - 3 + 'pt',
              }"
              v-for="(item, index) in tabelDataObj[page]"
              :key="index"
              @click="deleteRowFn(index + 1, page)"
            >
              <td
                @click="
                  changeTableFile(
                    page,
                    index,
                    'WeldSeamNumber',
                    item.WeldSeamNumber
                  )
                "
                style="
                  width: 92pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.WeldSeamNumber }}
                </p>
              </td>
              <td
                @click="changeTableFile(page, index, 'Grade', item.Grade)"
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-size: 13px;
                    font-family: '宋体';
                    letter-spacing: 0.7px;
                    text-wrap: nowrap;
                  "
                >
                  {{ item.Grade }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(
                    page,
                    index,
                    'DetectionLength',
                    item.DetectionLength
                  )
                "
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.DetectionLength }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(
                    page,
                    index,
                    'WeldingSpecification',
                    item.WeldingSpecification
                  )
                "
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.WeldingSpecification }}
                </p>
              </td>
              <td
                @click="changeTableFile(page, index, 'Model', item.Model)"
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  text-wrap: nowrap;
                  vertical-align: middle;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-size: 13px;
                    font-family: '宋体';
                  "
                >
                  {{ item.Model }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(
                    page,
                    index,
                    'SerialNumber',
                    item.SerialNumber
                  )
                "
                style="
                  width: 20pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.SerialNumber }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(page, index, 'XCoordinate', item.XCoordinate)
                "
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.XCoordinate }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(page, index, 'YCoordinate', item.YCoordinate)
                "
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.YCoordinate }}
                </p>
              </td>
              <td
                @click="changeTableFile(page, index, 'Depth', item.Depth)"
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.Depth }}
                </p>
              </td>
              <td
                @click="changeTableFile(page, index, 'Length', item.Length)"
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.Length }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(page, index, 'Amplitude', item.Amplitude)
                "
                style="
                  width: 30pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  class="s12"
                  style="
                    text-indent: 0pt;
                    text-align: center;
                    font-family: 'Times New Roman';
                  "
                >
                  {{ item.Amplitude }}
                </p>
              </td>
              <td
                @click="
                  changeTableFile(page, index, 'Evaluation', item.Evaluation)
                "
                style="
                  width: 35pt;
                  border: 1px solid black !important;
                  vertical-align: middle;
                  text-wrap: nowrap;
                "
              >
                <p
                  v-if="item.Evaluation == '复检合格'"
                  class="s12"
                  style="text-indent: 0pt; text-align: center; font-size: 13px"
                >
                  <span> {{ item.Evaluation.slice(0, 2) }}</span>
                  <br />
                  <span> {{ item.Evaluation.slice(2, 4) }}</span>
                </p>
                <p
                  v-else
                  class="s12"
                  style="text-indent: 0pt; text-align: center; font-size: 13px"
                >
                  <span> {{ item.Evaluation }}</span>
                </p>
              </td>
            </tr>
            <tr style="height: 126pt" v-if="page == pageTotal">
              <td
                style="
                  width: 92pt;
                  border: 1px solid black !important;
                "
              >
                <p style="text-indent: 0pt; text-align: left"><br /></p>
                <p
                  class="s12"
                  style="
                    padding-left: 2pt;
                    text-indent: 0pt;
                    text-align: center;
                    font-family: '宋体';
                  "
                >
                  备注
                </p>
              </td>
              <td
                style="
                  width: 376pt;
                  border: 1px solid black !important;
                "
                colspan="11"
              >
                <p
                  class="s12"
                  style="
                    padding-left: 2pt;
                    text-indent: 0pt;
                    text-align: justify;
                    line-height: 1.3;
                  "
                  v-for="(item, index) in remark.split('；')"
                  :key="item"
                >
                  <span style="font-family: 'Times New Roman'"
                    >{{ index + 1 }}.</span
                  >{{ item.length != 0 ? item + "；" : "" }}
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div >
          <h2 style="text-indent: 0pt; text-align: center">注意事项</h2>
          <p
            class="s14"
            style="
              padding-top: 20pt;
              padding-left: 23pt;
              text-indent: -10pt;
              text-align: left;
              line-height: 1.2;
            "
          >
            1.报告封面、第一页及骑缝未加盖“检测专用章”无效。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 23pt;
              text-indent: -10pt;
              text-align: left;
              line-height: 1.2;
            "
          >
            2.未经书面批准不得复制报告（完整复制除外）。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 23pt;
              text-indent: -10pt;
              text-align: left;
              line-height: 1.2;
            "
          >
            3.报告无主检、审核和批准人签字无效。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 23pt;
              text-indent: -10pt;
              text-align: left;
              line-height: 1.2;
            "
          >
            4.报告涂改无效。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 23pt;
              text-indent: -10pt;
              line-height: 150%;
              text-align: left;
              line-height: 1.2;
            "
          >
            5.对检测报告若有异议，应于收到报告之日起十五日内向检测单位提出，逾期未提出异议
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 23pt;
              text-indent: -10pt;
              line-height: 150%;
              text-align: left;
              line-height: 1.2;
            "
          >
            <span style="color: transparent">5.</span>的，视为认可检测结果。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 23pt;
              text-indent: -10pt;
              text-align: left;
              line-height: 1.2;
            "
          >
            6.当本机构不负责抽样时，仅对收到的样品负责。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 22pt;
              text-indent: -9pt;
              text-align: left;
              line-height: 1.2;
            "
          >
            7.客户委托检测时，检测报告带*号的项目内容由委托方提供，本机构不承担确认职责。
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 22pt;
              text-indent: -9pt;
              line-height: 150%;
              text-align: left;
              line-height: 1.2;
            "
          >
            8.合同约定需要保留的样品应在收到检测报告后十五日内领取，逾期未领取的由本机构按
          </p>
          <p
            class="s14"
            style="
              padding-top: 7pt;
              padding-left: 22pt;
              text-indent: -9pt;
              line-height: 150%;
              text-align: left;
              line-height: 1.2;
            "
          >
            <span style="color: transparent">5.</span>照内部规定进行处理。
          </p>
          <hr
            style="
              width: 295px;
              margin: 0 auto;
              border: 1px solid black;
              margin-top: 20px;
              margin-bottom: 25px;
            "
          />
          <p
            style="
              padding-left: 13pt;
              text-indent: 0pt;
              text-align: left;
              line-height: 1.3;
            "
          >
            联系方式：
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            总部：中钢集团郑州金属制品研究院股份有限公司/国家金属制品质量检验检测中心
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：河南省郑州市高新技术产业开发区化工路<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >172</span
            >号
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              text-align: left;
              line-height: 1.3;
            "
          >
            电话：<span style="font-family: 'Times New Roman'"
              >0371-67611405</span
            ><span style="font-family: 'Times New Roman'; margin-left: 15px"
              >67998209</span
            ><span style="margin-left: 105px"
              >传真：<span style="font-family: 'Times New Roman'"
                >0371-67998210</span
              ></span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            邮箱：<span style="font-family: 'Times New Roman'"
              >jszpjc@163.com</span
            ><span style="margin-left: 173px">邮政编码：</span
            ><span style="font-family: 'Times New Roman'">450001</span>
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所
            <span style="font-family: 'Times New Roman'">1</span
            >：中钢集团郑州金属制品研究院股份有限公司焦作分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：河南省焦作市武陟县产业集聚区河朔大道与兴业路交叉口东<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >600</span
            >米 电话：<span style="font-family: 'Times New Roman'"
              >0371-67998200</span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所
            <span style="font-family: 'Times New Roman'">2</span
            >：中钢集团郑州金属制品研究院股份有限公司华北分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：天津市西青区精武镇学府工业区慧深道<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >33</span
            >号聚鑫鑫<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >6</span
            >号楼 电话：<span style="font-family: 'Times New Roman'"
              >022-66265658</span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所
            <span style="font-family: 'Times New Roman'">3</span
            >：中钢集团郑州金属制品研究院股份有限公司广东分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：广东省广州市增城区新塘镇沙埔官道村站前路<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >4</span
            >号 电话：<span style="font-family: 'Times New Roman'"
              >020-82777786</span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所
            <span style="font-family: 'Times New Roman'">4</span
            >：中钢集团郑州金属制品研究院股份有限公司安徽分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：安徽省马鞍山市雨山区华山南路<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >505</span
            >号 电话：<span style="font-family: 'Times New Roman'"
              >0555-3670687</span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所
            <span style="font-family: 'Times New Roman'">5</span
            >：中钢集团郑州金属制品研究院股份有限公司四川分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：四川省成都经济技术开发区(龙泉驿区)经开区南四路<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >228</span
            >号 电话：<span style="font-family: 'Times New Roman'"
              >028-88432112</span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所
            <span style="font-family: 'Times New Roman'">6</span
            >：中钢集团郑州金属制品研究院股份有限公司云南分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：云南省昆明市大板桥街道办事处西冲社区昆明国际印刷包装城<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >D1-4-1</span
            >号地块
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            电话：<span style="font-family: 'Times New Roman'"
              >0871-63188209</span
            >
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            分场所<span style="font-family: 'Times New Roman'">7</span
            >：中钢集团郑州金属制品研究院股份有限公司上海分公司
          </p>
          <p
            style="
              padding-top: 1pt;
              padding-left: 13pt;
              text-indent: 0pt;
              line-height: 109%;
              text-align: left;
              line-height: 1.3;
            "
          >
            地址：上海市宝山区杨南路<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >709</span
            >号<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >1</span
            >幢<span
              style="
                font-family: 'Times New Roman';
                margin-left: 2px;
                margin-right: 2px;
              "
              >A</span
            >厂房 电话：<span style="font-family: 'Times New Roman'"
              >021-56166650</span
            >
          </p>
        </div>
      </div>
    </div>
    <div
      style="
        width: 30vw;
        border: 1px solid #ccc;
        padding: 10px;
        height: 90vh;
        overflow: auto;
      "
    >
      <pdfCtr
        ref="pdfCtrRef"
        :changeImageUrl="changeImageUrl"
        :urlType="urlType"
        :pageObj="pageObj"
        @exportMultiPagePdf="exportMultiPagePdf"
        @changePhotoFn="changePhotoFn"
        @copyRows="copyRows"
        @deleteRows="deleteRows"
        @deleteRowsPage1="deleteRowsPage1"
        @insertRows="insertRows"
        @changeTabelFiledFn="changeTabelFiledFn"
        @changeImageStyle="changeImageStyle"
        :changeTabelFiled="changeTabelFiled"
        @changeTextFn="changeTextFn"
        @addRows="addRows"
        @changeTableHeightFn="changeTableHeightFn"
        :changeText="changeText"
        :textType="textType"
        :remark="remark"
        @changeTableRemark="changeTableRemark"
        @changeLineHeight="changeLineHeight"
        @changeSpacing="changeSpacing"
        :tabelDataObj="tabelDataObj"
        :selectSpace="selectSpace"
        :textTablePage="textTablePage"
        @changePageOneTextFn="changePageOneTextFn"
        @addPageRow="addPageRow"
      ></pdfCtr>
    </div>
  </div>
</template>

<script>
import pdfCtr from "./pdfCtr.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import * as jspdf from "jspdf";
import { reportFileds, reportPage1 } from "@/utils/report.js";
export default {
  data() {
    return {
      imgUrlObj: {
        imageUrl1: {
          url: require("../img/Image_001.png"),
          w: 122.64,
          h: 90.58,
          left: 50,
          top: 80,
          show:true
        },
        imageUrl2: {
          url: require("../img/Image_002.png"),
          w: 94.59,
          h: 92.98,
          left: 180,
          top: 80,
          show:true
        },
        imageUrl3: {
          url: require("../img/Image_003.png"),
          w: 175.55,
          h: 92.98,
          left: 280,
          top: 80,
          show:true
        },
        imageUrl4: {
          url: require("../img/Image_004.png"),
          w: 154,
          h: 154,
          left: 18,
          top: -15,
          show:true
        },
        imageUrl5: {
          url: require("../img/Image_005.jpg"),
          w: 56,
          h: 55,
          left: 560,
          top: 6,
          show:true
        },
        imageUrl6: {
          url: require("../img/Image_006.png"),
          w: 162,
          h: 162,
          left: 438,
          top: 601,
          show:true
        },
        imageUrl7: {
          url: require("../img/Image_007.jpg"),
          w: 93,
          h: 59,
          left: 80,
          top: 5,
          show:true
        },
        imageUrl8: {
          url: require("../img/Image_008.jpg"),
          w: 85,
          h: 38,
          left: 530,
          top: 10,
          show:true
        },
        imageUrl9: {
          url: require("../img/Image_009.jpg"),
          w: 117,
          h: 50,
          left: 320,
          top: 5,
          show:true
        },
        imageUrl11: {
          url: require("../img/Image_011.jpg"),
          w: 644,
          h: 422,
          left: 0,
          top: 20,
          show:true
        },
        imageUrl13: {
          url: require("../img/Image_013.jpg"),
          w: 495,
          h: 401,
          left: 80,
          top: 10,
          show:true
        },
        imageUrl14: {
          url: require("../img/Image_014.jpg"),
          w: 199,
          h: 153,
          left: 80,
          top: 450,
          show:true
        },
        imageUrl15: {
          url: require("../img/Image_015.jpg"),
          w: 90,
          h: 67,
          left: 350,
          top: 480,
          show:true
        },
      },
      tableData: [
        {
          WeldSeamNumber: "X-Z1AM/2AM",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1AD/2AD",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1AF1/2AF1",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "40*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1AF2/2AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "40*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3AM/4AM",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "34*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3AD/4AD",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "34*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3AF1/4AF1",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "28*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3AF2/4AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "28*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4AM/5AM",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4AD/5AD",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4AF1/5AF1",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4AF2/5AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5AM/6AM",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5AD/6AD",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5AF1/6AF1",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5AF2/6AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6AM/7AM",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6AD/7AD",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6AF1/7AF1",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6AF2/7AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7AM/8AM",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7AD/8AD",
          Grade: "Ⅰ级",
          DetectionLength: 2070,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7AF1/8AF1",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7AF2/8AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1BM/2BM",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1BD/2BD",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1BF1/2BF1",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "40*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z1BF2/2BF2",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "40*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3BM/4BM",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "34*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3BD/4BD",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "34*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3BF1/4BF1",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z3BF2/4BF2",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4BM/5BM",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4BD/5BD",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4BF1/5BF1",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z4BF2/5BF2",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5BM/6BM",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5BD/6BD",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5BF1/6BF1",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z5BF2/6BF2",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6BM/7BM",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6BD/7BD",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6BF1/7BF1",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z6BF2/7BF2",
          Grade: "Ⅰ级",
          DetectionLength: 3227,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7BM/8BM",
          Grade: "Ⅰ级",
          DetectionLength: 400,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7BD/8BD",
          Grade: "Ⅰ级",
          DetectionLength: 400,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7BF1/8BF1",
          Grade: "Ⅰ级",
          DetectionLength: 400,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-Z7BF2/8BF2",
          Grade: "Ⅰ级",
          DetectionLength: 400,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1M/Z1AM",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1D/Z1AD",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1F1/Z1AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1F2/Z1AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1M/Z1BM",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "UT1",
          XCoordinate: 2050,
          YCoordinate: -3,
          Depth: "19-20",
          Length: 70,
          Amplitude: 13.1,
          Evaluation: "不合格",
        },
        {
          WeldSeamNumber: "X-HL1D/Z1BD",
          Grade: "Ⅰ级",
          DetectionLength: 2120,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1F1/Z1BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1F2/Z1BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "34*34",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2M01/Z1AM",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2D01/Z1AD",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F1/Z1AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F2/Z1AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2M01/Z1BM",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2D01/Z1BD",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F1/Z1BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F2/Z1BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2M02/Z1AM",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2D02/Z1AD",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F3/Z1AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F4/Z1AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2M02/Z1BM",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2D02/Z1BD",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F3/Z1BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F4/Z1BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2M03/Z2AM",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2D03/Z2AD",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F5/Z2AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F6/Z2AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2M03/Z2BM",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2D03/Z2BD",
          Grade: "Ⅰ级",
          DetectionLength: 850,
          WeldingSpecification: "20*20",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F5/Z2BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL2F6/Z2BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M01/Z2AM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M01/Z2BM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D01/Z2AD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D01/Z2BD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F1/Z2AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F1/Z2BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M02/Z2AM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "UT1",
          XCoordinate: 160,
          YCoordinate: 1,
          Depth: "25 - 26",
          Length: 90,
          Amplitude: 9.4,
          Evaluation: "不合格",
        },
        {
          WeldSeamNumber: "X-HL3M02/Z2BM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D02/Z2AD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D02/Z2BD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F2/Z2AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F2/Z2BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M03/Z3AM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M03/Z3BM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D03/Z3AD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D03/Z3BD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F3/Z3AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F3/Z3BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M04/Z3AM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M04/Z3BM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "UT1",
          XCoordinate: 310,
          YCoordinate: 4,
          Depth: "22-25",
          Length: 240,
          Amplitude: 11,
          Evaluation: "不合格",
        },
        {
          WeldSeamNumber: "X-HL3D04/Z3AD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D04/Z3BD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F4/Z3AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F4/Z3BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M05/Z4AM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3M05/Z4BM",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D05/Z4AD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3D05/Z4BD",
          Grade: "Ⅰ级",
          DetectionLength: 550,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F5/Z4AF2",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL3F5/Z4BF1",
          Grade: "Ⅰ级",
          DetectionLength: 2100,
          WeldingSpecification: "16*16",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "合格",
        },
        {
          WeldSeamNumber: "X-HL1M/Z1BM",
          Grade: "Ⅰ级",
          DetectionLength: 120,
          WeldingSpecification: "24*24",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "复检合格",
        },
        {
          WeldSeamNumber: "X-HL3M02/Z2AM",
          Grade: "Ⅰ级",
          DetectionLength: 190,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "复检合格",
        },
        {
          WeldSeamNumber: "X-HL3M04/Z3BM",
          Grade: "Ⅰ级",
          DetectionLength: 290,
          WeldingSpecification: "28*28",
          Model: "V型",
          SerialNumber: "/",
          XCoordinate: "/",
          YCoordinate: "/",
          Depth: "/",
          Length: "/",
          Amplitude: "/",
          Evaluation: "复检合格",
        },
      ],
      spaceObj: {
        result: 20,
        date: 22,
      },
      selectSpace: "",
      selectSpaceType: "",
      reportFileds: reportFileds,
      reportPage1: reportPage1,
      changeImageUrl: "",
      urlType: "",
      changeText: "",
      textType: "",
      isShow1: true,
      pageNumber: "",
      changeTabelFiled: "",
      selectIndex: "",
      tableFiled: "",
      pageObj: {},
      tabelDataObj: { 1: [] },
      remark: `焊缝编号均由委托方提供，且在设计图纸中备案，编号规则：构件分段编号X- HL1~X-HL4、X-Z1A~X-Z7A、X-Z1B~X-Z7B，方向说明：“X侧”表示小桩号侧，“D侧”表示大桩号侧，“Z侧”表示左侧，“Y侧”表示右侧(人站在小桩号侧看向大桩号侧，左手边为Z侧， 右手边为Y侧)，“M侧”表示顶板侧。单元件编码说明：X/Y/Z- GL/Z*#D/M/F/HG（例如X-GL1AD）联段编码（X表示144m正线，Z表示136m左联， Y表示136右联）节段序号（GL表示拱肋、Z表示系梁）分段识别码（A、B）单元件识别码（D表示底板，M表示顶板，F表示腹板，HG表示隔板）；
缺陷定位方式：面向焊缝，以最上端/最左端为0点，向下/向右进行检测，X表示缺欠起始位置至0点的距离，Y表示缺陷偏移焊缝中心的距离，Z表示缺陷深度；
焊缝规格的表示型式客户要求与设计图纸上保持一致`,
      tableHeight: 18,
      maxPageHeight: 576,
      tablePageOneID: undefined,
      tablePageOneType: undefined,
      textTablePage: 0,
    };
  },

  computed: {
    pageTotal() {
      if (!Array.isArray(this.tableData)) {
        this.tableData = [];
      }
      let pageHeight = 0;
      let maxNum = Object.values(this.tabelDataObj).length;
      this.tabelDataObj[maxNum].forEach((item) => {
        if (item.Evaluation == "复检合格") {
          pageHeight += 2 * this.tableHeight;
        } else {
          pageHeight += this.tableHeight;
        }
      });
      if (pageHeight >= 18 * 25) {
        this.tabelDataObj[maxNum + 1] = [];
        this.$forceUpdate();
        return maxNum + 1;
      }
      this.$forceUpdate();
      return maxNum;
      // const lengths = this.tableData.length;
      // const pages = Math.ceil(lengths / 32);
      // const num = lengths % 32;
      // if (num > 25 || num == 0) {
      //   this.$forceUpdate();
      //   return pages + 1;
      // }
      // this.$forceUpdate();
      // return pages;
    },
  },
  /**
   * 创建完毕
   */
  created() {
    this.pageTableFn();
  },
  components: {
    pdfCtr,
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  watch: {
    tableHeight: {
      handler: function (height) {
        this.pageTableFn();
      },
    },
  },
  methods: {
    async exportMultiPagePdf() {
      // 导出pdf
      const acceptance = document.querySelector("#myContent");
      // return
      html2pdf()
        .set({
          margin: 1.1,
          image: { type: "jpeg", quality: 0.98 },
          filename: `ceshi.pdf`,
          jsPDF: { format: "a4", origin: "portrait",hotfixes: ['px_scaling']},
          pagebreak: { mode: ["avoid-all", "css", "legacy"] },
          html2canvas: { scale: 4,dpi: 300,useCORS: true },
        })
        .from(acceptance)
        .save();

      const panelPDF = document.querySelector("#inStore");
    },
    // 分页
    pageTableFn() {
      this.tabelDataObj = {
        1: [],
      };
      let pageHeight = 0;
      let pageNumber = 1;
      this.tableData.forEach((item) => {
        if (pageHeight < this.maxPageHeight) {
          if (item.Evaluation == "复检合格") {
            pageHeight += 2 * this.tableHeight;
            this.tabelDataObj[pageNumber].push(item);
          } else {
            pageHeight += this.tableHeight;
            this.tabelDataObj[pageNumber].push(item);
          }
        } else {
          pageHeight = 0;
          pageNumber++;
          this.tabelDataObj[pageNumber] = [];
          if (item.Evaluation == "复检合格") {
            pageHeight += 2 * this.tableHeight;
            this.tabelDataObj[pageNumber].push(item);
          } else {
            pageHeight += this.tableHeight;
            this.tabelDataObj[pageNumber].push(item);
          }
        }
      });
      this.$forceUpdate();
      console.log(this.tabelDataObj, "this.tabelDataObj");
    },
    // 删除行
    deleteRowFn(rowConut, pageNumber) {
      console.log(rowConut, pageNumber);

      this.pageObj = {
        rowConut,
        pageNumber: pageNumber + 3,
      };
      this.pageTableFn();
    },
    // insertRows(insertID, total) {
    //   console.log("insertID" + insertID)
    //   const arr = [];
    //   for (let i = 0; i < total; i++) {
    //     arr.push({
    //       WeldSeamNumber: "",
    //       Grade: "",
    //       DetectionLength: 0,
    //       WeldingSpecification: "",
    //       Model: "",
    //       SerialNumber: "",
    //       XCoordinate: "",
    //       YCoordinate: "",
    //       Depth: "",
    //       Length: "",
    //       Amplitude: "",
    //       Evaluation: "",
    //     });
    //   }
    //
    //   this.tableData.splice(insertID, 0, ...arr);
    //   this.pageTableFn();
    // },
    insertRows(type, total, insertID) {
      console.log("insertID" + insertID)
      if (type == 4) {
        const arr = [];
        for (let i = 0; i < total; i++) {
          arr.push({
            WeldSeamNumber: "",
            Grade: "",
            DetectionLength: 0,
            WeldingSpecification: "",
            Model: "",
            SerialNumber: "",
            XCoordinate: "",
            YCoordinate: "",
            Depth: "",
            Length: "",
            Amplitude: "",
            Evaluation: "",
          });
        }
        this.tableData.splice(insertID, 0, ...arr);
        this.pageTableFn();
      } else {
        const cols = insertID;
        const arr = [];
        for (let i = 0; i < total; i++) {
          if (cols == 2) {
            arr.push({
              fieldName: "",
              fieldValue: "",
              textAlign:"left",
              lineHeight:10
            });
          } else {
            arr.push({
              fieldName: "",
              fieldValue: "",
              fieldName2: "",
              fieldValue2: "",
              lineHeight:10
            });
          }
        }
        this.reportPage1.splice(this.tablePageOneID+1, 0, ...arr);
      }
    },
    deleteRows(delID, delToltal) {
      this.tableData = this.tableData.filter((item, index) => {
        if (index + 1 < delID || index + 1 > delID + delToltal - 1) {
          return item;
        }
      });
      this.pageTableFn();
    },
    deleteRowsPage1(delToltal) {
      this.reportPage1 = this.reportPage1.filter((item, index) => {
        if (
          index < this.tablePageOneID ||
          index > this.tablePageOneID + delToltal - 1
        ) {
          return item;
        }
      });
    },
    changeTableRemark(remark) {
      this.remark = remark;
    },
    changeTableFile(page, pageindex, type, item) {
      console.log("page    kaishi : "+ page,pageindex, type, item);
      this.changeTabelFiled = item;
      this.$refs["pdfCtrRef"].getTabelFiled(this.changeTabelFiled, 4);
      this.tableFiled = type;
      let id = 0;
      for (let i = 1; i < page; i++) {
        id += this.tabelDataObj[i].length;
      }
      this.selectIndex = id + pageindex;
      console.log("this.selectIndex",this.selectIndex)
    },
    copyRows(arr) {
      this.tableData.push(...arr);
      this.pageTableFn();
    },
    addRows() {
      this.tableData.push({
        WeldSeamNumber: "",
        Grade: "",
        DetectionLength: 0,
        WeldingSpecification: "",
        Model: "",
        SerialNumber: "",
        XCoordinate: "",
        YCoordinate: "",
        Depth: "",
        Length: "",
        Amplitude: "",
        Evaluation: "",
      });
      this.pageTableFn();
    },
    changeLineHeight(lineHeight) {
      this.reportPage1[this.tablePageOneID].lineHeight = lineHeight;
      this.$forceUpdate()

    },
    imageClickFn(urlType) {
      this.urlType = urlType;
      console.log("this.urlType" + this.urlType)
      this.changeImageUrl = this.imgUrlObj[urlType];
      console.log("this.urlType" + this.changeImageUrl.show)
    },
    textClickFn(page, textType) {
      this.textType = textType;
      this.pageNumber = page;
      this.changeText = this.reportFileds[page][textType];
      this.textTablePage = 0;
      if (textType == "testConclusion") {
        this.$refs["pdfCtrRef"].getSpacing(this.spaceObj.result);
        this.selectSpaceType = "result";
      } else if (textType == "dateIssue") {
        this.$refs["pdfCtrRef"].getSpacing(this.spaceObj.date);
        this.selectSpaceType = "date";
      }
    },
    changeTableHeightFn(height) {
      this.tableHeight = height;
    },
    changeSpacing(num) {
      this.spaceObj[this.selectSpaceType] = num;
    },
    changeTextFn(text, textType) {
      this.reportFileds[this.pageNumber][textType] = text;
      this.$forceUpdate();
    },
    changePageOneTextFn(text) {
      this.reportPage1[this.tablePageOneID][this.tablePageOneType] = text;
      this.$forceUpdate();
    },
    changeTabelFiledFn(filed) {
      if (this.selectIndex == "") {
        return;
      }
      this.tableData[this.selectIndex][this.tableFiled] = filed;
      this.pageTableFn();
    },
    changePhotoFn(imageUrl, type) {
      this.imgUrlObj[type] = imageUrl;
      this.$forceUpdate();
    },
    textClickPageOneFn(idx, type, val) {
      console.log(idx, type, "idx,type");
      this.tablePageOneID = idx;
      this.pageObj = {
        rowConut: idx + 1,
        pageNumber: 1,
      };
      this.tablePageOneType = type;
      this.changeText = val;
      this.textTablePage = 1;
      this.$refs["pdfCtrRef"].getTabelFiled(this.changeTabelFiled, 1,this.reportPage1[idx].lineHeight);
    },

    changeImageStyle(imageStyle, type) {

      switch (type) {
        case 1:
          this.imageUrlW1 = imageStyle.imageUrlW;
          this.imageUrlH1 = imageStyle.imageUrlH;
          this.isShow1 = imageStyle.isShow;
          break;
        case 2:
          // this.imageUrl2 = imageUrl
          break;
        case 3:
          // this.imageUrl3 = imageUrl
          break;
      }
    },
    addPageRow(cols) {
      if (cols == 2) {
        this.reportPage1.push({
          fieldName: "",
          fieldValue: "",
          textAlign:"left",
          lineHeight: 10,
        });
      } else {
        this.reportPage1.push({
          fieldName: "",
          fieldValue: "",
          fieldName2: "",
          fieldValue2: "",
          lineHeight: 10,
        });
      }
      console.log(this.reportPage1,"this.reportPage1");

    },
  },
};
</script>
<style scoped>
/* 定义英文字体 */
@font-face {
  font-family: "EN-Times";
  src: local("Times New Roman");
  unicode-range: U+000-5FF, U+1E00-1FFF; /* 拉丁字母、数字、标点 */
}

/* 定义中文字体 */
@font-face {
  font-family: "CN-SimSun";
  src: local("SimSun");
  unicode-range: U+4E00-9FFF; /* 汉字范围 */
}

* {
  margin: 0;
  padding: 0;
  text-indent: 0;
  background-color: #fff;
}

.body {
  width: 210mm;
  margin: 0 auto;
  height: 90vh;
  overflow: auto;

  /* background-color: yellow; */
}

.page {
  height: 297mm;
  overflow: hidden;
  position: relative;
}
.b1 {
  width: 647px;
  margin: 0 auto;
}

.s1 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
  vertical-align: 5pt;
}

.s2 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}

h1 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: 900 !important;
  text-decoration: none;
  font-size: 72.14px;
  text-shadow: 1px 1px 0px black;
}

.s3 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 15pt;
}

.s4 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 15pt;
}

.s5 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 18pt;
}

h4 {
  color: black;
  font-family: "Microsoft JhengHei", sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 18pt;
}

h3 {
  color: black;
  font-family: "Microsoft JhengHei", sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 20pt;
}

p {
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
  margin: 0pt;
  font-family: "EN-Times", "CN-SimSun", sans-serif;
}

.s6 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}

.s7 {
  color: black;
  font-family: "SimSun";
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}

.s8 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}

.s9 {
  color: black;
  font-family: Cambria, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}

.s10 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}

.s11 {
  color: black;
  font-family: "Times New Roman", serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 11pt;
}

.s12 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}

.s13 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10.5pt;
}

h2 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  font-size: 22pt;
}

.s14 {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}

.a {
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 11pt;
}

li {
  display: block;
}

#l1 {
  padding-left: 0pt;
  counter-reset: c1 1;
}

#l1 > li > *:first-child:before {
  counter-increment: c1;
  content: counter(c1, decimal) ". ";
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}

#l1 > li:first-child > *:first-child:before {
  counter-increment: c1 0;
}

li {
  display: block;
}

#l2 {
  padding-left: 0pt;
  counter-reset: d1 1;
}

#l2 > li > *:first-child:before {
  counter-increment: d1;
  content: counter(d1, decimal) ". ";
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 10pt;
}

#l2 > li:first-child > *:first-child:before {
  counter-increment: d1 0;
}

li {
  display: block;
}

#l3 {
  padding-left: 0pt;
  counter-reset: e1 1;
}

#l3 > li > *:first-child:before {
  counter-increment: e1;
  content: counter(e1, decimal) ". ";
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 9pt;
}

#l3 > li:first-child > *:first-child:before {
  counter-increment: e1 0;
}

li {
  display: block;
}

#l4 {
  padding-left: 0pt;
  counter-reset: f1 1;
}

#l4 > li > *:first-child:before {
  counter-increment: f1;
  content: counter(f1, decimal) ". ";
  color: black;
  font-family: 宋体;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  font-size: 12pt;
}

#l4 > li:first-child > *:first-child:before {
  counter-increment: f1 0;
}

table,
tbody {
  vertical-align: top;
  overflow: visible;
}
div,
p,
span {
  font-family: "EN-Times", "CN-SimSun", sans-serif !important;
}
</style>







// WEBPACK FOOTER //
// src/views/report/ReportPdf.vue